import { useCallback } from "react";

import { useTranslation } from "react-i18next";

import { TextToast } from "@/uiKit/atoms/Toast.tsx";

export const useCopyToClipboard = () => {
  const { t } = useTranslation();

  return useCallback(
    async (text: string) => {
      if (!navigator.clipboard) {
        TextToast.error(t("clipboard.unsupported"));
      }

      try {
        await navigator.clipboard.writeText(text);
        TextToast.success(t("clipboard.copied"));
      } catch {
        TextToast.error(t("clipboard.failed"));
      }
    },
    [t],
  );
};
